import { workerstationService } from "@workerstation/shared/effect/service";
import { Context, Effect } from "effect";
import type { RuntimeDependencyError } from "../errors/dependency.ts";

export class Clock extends workerstationService<Clock, {
  readonly milliseconds: Effect.Effect<number, RuntimeDependencyError>;
}>()("Clock") {}
